import { render, staticRenderFns } from "./active-setting.vue?vue&type=template&id=00938de4&"
import script from "./active-setting.vue?vue&type=script&lang=js&"
export * from "./active-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports